<template>
  <div v-if="subcategory !== null">
    <!-- Product Spec -->
    <div class="d-flex justify-space-between mb-2">
      <h3>Product Spec</h3>
      <button
        class="btn"
        @click="toProductInfoEditSpecEdit"
      >
        <v-icon class="mr-2">edit</v-icon>
        <span>前往編輯Spec欄位</span>
      </button>
    </div>
    <div class="mb-5">資訊將顯示於產品頁、產品比較表，最右邊的X按鈕將移除綁定。</div>
    <div>
      <!-- 規格 -->
      <div
        v-for="(item, i) in subcategory.specs"
        :key="item.id"
      >
        <label class="form-item pa-5 d-flex" v-if="!item.is_customized">
          <div class="w-267px">
            <h4>{{ item.title }}</h4>
          </div>
          <div class="w-100 d-flex">
            <div class="flex-grow-1 flex-basis-0">
              <div class="form-input-group d-flex"
                   v-for="(option, oi) in product.specs[i].options"
                   :key="oi"
              >
                <v-textarea
                  v-model="option.title"
                  row-height="7"
                  auto-grow
                  outlined
                  dense
                ></v-textarea>
                <button class="btn square ml-5"
                        v-if="oi === 0"
                        @click="addSpec(product.specs[i].options)">
                  <v-icon>add</v-icon>
                </button>
                <button class="btn square ml-5"
                        v-if="oi === 0"
                        @click="detachOptions(i)">
                  <v-icon>clear</v-icon>
                </button>
                <button class="btn square ml-5"
                        v-if="oi > 0"
                        @click="removeSpec(product.specs[i].options, oi)"
                >
                  <v-icon>delete</v-icon>
                </button>
              </div>
            </div>
          </div>
        </label>
      </div>

      <!-- 備註 -->
      <div class="form-item pa-5 d-flex">
        <div class="w-267px">
          <h4>備註</h4>
        </div>
        <div class="w-100 d-flex">
          <div class="flex-grow-1 flex-basis-0">
            <editor
              v-model="product.remark"
              :plugins="'link lists'"
              :toolbar="'link|bullist numlist|outdent indent'"
            />
          </div>
        </div>
      </div>
    </div>

    <!-- Product Filter -->
    <div class="d-flex justify-space-between mb-2 mt-5">
      <h3>Filter將顯示於Product Category Page</h3>
      <button
        class="btn"
        @click="toProductInfoEditFilterEdit"
      >
        <v-icon class="mr-2">edit</v-icon>
        <span>前往編輯Filter欄位</span>
      </button>
    </div>
    <div class="mb-5">1.下方核取欄位用來設定前台顯示否 2.若需調整前台顯示次序請告知工程師 3.若本文框留空者會同步移除全語系的filter 4.按下[+]可新增一筆</div>
    <div>
      <!-- 特點 -->
      <div
        v-for="(item, i) in subcategory.specs"
        :key="item.id"
      >
        <label class="form-item pa-5 d-flex" v-if="item.is_customized">
          <div class="w-267px">
            <h4>{{ item.title }}</h4>
          </div>
          <div class="w-100 d-flex">
            <div class="flex-grow-1 flex-basis-0">
              <div class="form-input-group d-flex"
                   v-for="(option, oi) in product.specs[i].options"
                   :key="oi">
                <div>
                  <input class="filter-opt"
                    type="checkbox"
                    :id="String(i) + String(oi)"
                    :name="option.title"
                    :value="option.id"
                    v-model="option.status"
                    >
                    <label
                      :for="String(i) + String(oi)"
                      class="checkbox"
                    >
                      <span>
                        {{ option.id }}
                      </span>
                    </label>
                    <br>
                </div>
                <div class="ml-7">
                  <v-textarea
                      v-model="option.title"
                      :items="findFilter(option.id)"
                      item-value="id"
                      item-text="title"
                      row-height="7"
                      auto-grow
                      outlined
                      dense
                    ></v-textarea>
                </div>
                <button class="btn square ml-5"
                    v-if="oi === 0"
                    @click="addSpec(product.specs[i].options)">
                    <v-icon>add</v-icon>
                </button>
                <button class="btn square ml-5"
                        v-if="oi === 0 && isDetachOptions"
                        @click="detachOptions(i)">
                  <v-icon>clear</v-icon>
                </button>
                <button class="btn square ml-5"
                        @click="removeSpec(product.specs[i].options, oi)">
                  <v-icon>delete</v-icon>
                </button>
              </div>
            </div>
          </div>
        </label>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import Editor from '@/components/TinymceEditor.vue';

export default {
  props: {
    product: {
      type: Object,
      default: () => ({}),
    },
  },
  data: () => ({
    isDetachOptions: false,
  }),
  components: {
    Editor,
  },
  computed: {
    ...mapState('subcategory', ['subcategory']),
  },
  watch: {
    async findFilter(newValue) {
      if (newValue !== '') {
        return this.findFilterByCategory(newValue);
      }
      return [];
    },
  },
  methods: {
    ...mapActions('product', [
      'detachFilterOptions',
      'findById',
    ]),
    ...mapActions('subcategory', ['findFilterByCategory']),
    toProductInfoEditFilterEdit() {
      this.$router.push({
        name: 'ProductInfoEditFilterEdit',
        params: {
          id: this.subcategory.id,
        },
      });
    },
    toProductInfoEditSpecEdit() {
      this.$router.push({
        name: 'ProductInfoEditSpecEdit',
        params: {
          id: this.subcategory.id,
        },
      });
    },
    // 解除綁定
    detachOptions(i) {
      const ids = this.product.specs[i].options.map((o) => o.id).filter((o) => o != null);
      this.detachFilterOptions({
        id: this.product.id,
        ids,
      }).then(() => {
        this.product.specs[i].options = [];
        this.addSpec(this.product.specs[i].options);
      });
    },
    addSpec(target) {
      target.push({
        id: null,
        title: null,
      });
    },
    // 移除FilterOption
    removeSpec(target, index) {
      // alert('會同時移除全語系');
      target.splice(index, 1);
    },
    findFilter(newValue) {
      if (newValue !== '') {
        return this.findFilterByCategory(newValue);
      }
      return [];
    },
  },
};
</script>

<style lang="scss" scoped>
.form-input-group input[type='checkbox']{
  width:20px;
  height: 20px;
  border:1px solid #1e50c0 !important;
  caret-color: #1E50C1 !important;
  color:#1e50c0 !important;
}
.filter-opt{
  width:20px;
  height: 20px;
  border:1px solid #1e50c0 !important;
  caret-color: #1E50C1 !important;
  color:#1e50c0 !important;
}
</style>
